import React from "react"
import { Container } from "reactstrap"
import ExperienceDetail from "pagesV2/pro/Embedded/ExperienceDetail"

import { useTitle } from "hooks/useTitle"

import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"

export default function Trip() {
  const trip = useSelector(modelSelector("trip"))
  useTitle(trip.title)

  return (
    <div className="bg-light">
      <Container className="py-50">
        <ExperienceDetail mode={"guideBooking"} />
      </Container>
    </div>
  )
}
